<template>
  <div>
    <!-- MOBILE -->
    <div v-if="$vuetify.breakpoint.mobile && !dialog" class="d-flex align-center">
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-chip
            v-bind="attrs"
            v-on="on"
            label
            color="primary"
            outlined
            class="mr-2"
          >
            {{ rangeLabel }}
          </v-chip>
        </template>
        <v-list>
          <v-list-item
            v-for="shortcut in customShortcuts"
            :key="shortcut.key"
            @click="handleRangeChange({ shortcut: shortcut.value })"
          >
            <v-list-item-title>{{ shortcut.label }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-chip
            v-bind="attrs"
            v-on="on"
            label
            color="primary"
            outlined
            class="mr-2"
          >
            {{ bases.find(e => e.value == base)?.text }}
          </v-chip>
        </template>
        <v-list>
          <v-list-item
            v-for="baseOption in bases"
            :key="baseOption.value"
            @click="baseLocal = baseOption.value; refresh()"
          >
            <v-list-item-title>{{ baseOption.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-menu v-if="base !== 0 && ['msu', 'nsu'].includes(currentLeagueName)" offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-chip
            v-bind="attrs"
            v-on="on"
            label
            color="primary"
            outlined
            class="mr-2"
          >
            {{ merkkiOptions.find(e => e.value == markType)?.text }}
          </v-chip>
        </template>
        <v-list>
          <v-list-item
            v-for="option in merkkiOptions"
            :key="option.value"
            @click="markTypeLocal = option.value; refresh()"
          >
            <v-list-item-title>{{ option.text }}</v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>

      <v-spacer></v-spacer>
      <v-btn @click="showSettings = true" fab small text>
        <v-icon>mdi-cog-outline</v-icon>
      </v-btn>
      <v-dialog v-model="showSettings">
        <v-card class="pa-4">
          <LeagueTimeSettings @refresh="$emit('refresh')" :dialog="true" />
        </v-card>
      </v-dialog>
    </div>
    <!-- DESKTOP -->
    <div v-else :class="`mt-2 ${dialog ? '' : 'd-flex align-center'}`">
      <VueCtkDateTimePicker
        :value="range"
        @input="handleRangeChange"
        format="YYYY-MM-DD"
        output-format="x"
        range
        :custom-shortcuts="customShortcuts"
        dialog
        style="max-width: 140px; margin: 0;"
        label="Aikaväli"
        :no-value-to-custom-elem="true"
        auto-close
      >
        <v-btn
          v-tooltip="'Ajat aikaväliltä'"
          style="width: 100%; z-index: 0;"
          outlined
          small
        >
          <v-icon size="15" class="mr-2">mdi-calendar</v-icon>
          {{ rangeLabel }}
        </v-btn>
      </VueCtkDateTimePicker>
      <v-select
        dense
        label="Pesänväli"
        :items="bases"
        :style="!dialog ? `max-width: 130px;` : ''"
        item-text="text"
        item-value="value"
        :class="{ 'ml-4': !dialog, 'mt-8': dialog }"
        v-model="baseLocal"
        @change="refresh"
        hide-details
      ></v-select>
      <ChooseClubSelect
        v-if="currentTeam && !hideTeam"
        v-model="localClub"
        :class="{ 'ml-4': !dialog, 'mt-2': dialog }"
        :style="`margin-bottom: ${!dialog ? '-4' : '0'}px;`"
        :width="dialog ? '100%' : '300px'"
      />
    </div>
  </div>
</template>

<script>
import { mapMutations, mapGetters } from 'vuex'
import ChooseClubSelect from '../games/ChooseClubSelect.vue'

export default {
  props: ['dialog', 'hideTeam'],
  components: { ChooseClubSelect },
  name: 'LeagueTimeSettings',
  data: () => {
    return {
      hitDirections: [
        { text: "3-raja", value: "three_raja" },
        { text: "3-luukku", value: "three_luukku" },
        { text: "3-sauma", value: "three_sauma" },
        { text: "3-jatke", value: "three_jatke" },
        { text: "3-pussi", value: "three_pussi" },

        { text: "Välimiespomppu", value: "valimiespomppu" },
        { text: "Menopomppu", value: "menopomppu" },
        { text: "Pomppu etupelaajan yli", value: "etupelaaja_pomppu", explainer: "Pomppu, joka lyöty etupelaajan yli esimerkiksi takasen tahkoissa tai nollan käännetyssä." },
        { text: "Ylitysnäppi", value: "ylitysnappi" },
        { text: "Ohitus", value: "ohitus" },
        { text: "Tappi", value: "tappi" },
        { text: "Keski", value: "keski", explainer: "Keskitaka, maalyönti keskelle, keskikumura jne." },
        { text: "2-raja", value: "two_raja" },
        { text: "2-luukku", value: "two_luukku" },
        { text: "2-sauma", value: "two_sauma" },
        { text: "2-jatke", value: "two_jatke" },
        { text: "2-pussi", value: "two_pussi" },
      ],
      // merkkiOptions: [
      //   { text: "Lento / nopea", value: "lento" },
      //   { text: "Väärä pois", value: "vp" },
      //   { text: "Takamaila", value: "takamaila" },
      //   { text: "Kulmamaila", value: "kulmamaila" },
      //   { text: "Epäselvä maila", value: "epaselva_maila" },
      //   { text: "Viivästetty", value: "viivastetty" },
      //   { text: "Oma lähtö", value: "oma_lahto" },
      //   { text: "Epäselvä", value: "epaselva" },
      // ],
      showSettings: false
    }
  },
  mounted() {
    // Only set default range if no range is already set
    if (!this.range || (!this.range.start && !this.range.end)) {
      this.handleRangeChange({ shortcut: 'summer' })
    }
  },
  methods: {
    ...mapMutations('leaguetimes', [
      'SET_PLAYER_NAME',
      'SET_BASE',
      'SET_RANGE',
      'SET_MARK_TYPE',
      'SET_TEAM',
      'SET_IS_PLAY'
    ]),
    refresh() {
      this.$nextTick(() => {
        this.$emit('refresh')
      })
    },
    handleRangeChange(range) {
      console.log("range", range)
      // If the shortcut is 'year', override the range to 24.4. - 30.9. of the current year
      if (range.shortcut === 'summer') {
        const year = new Date().getFullYear();
        range.start = new Date(year, 3, 20).getTime(); // 24.4.
        range.end = new Date(year, 8, 30, 23, 59, 59, 999).getTime(); // 30.9.
      }
      this.SET_RANGE(range)
      this.refresh()
    },
    teamChanged() {
      this.refresh()
    },
    getDaysSinceApril15() {
      const today = new Date()
      const currentYear = today.getFullYear()
      const april15 = new Date(currentYear, 3, 15) // Month is 0-based, so 3 = April

      // If we're before April 15th this year, use last year's April 15th
      if (today < april15) {
        april15.setFullYear(currentYear - 1)
      }

      const diffTime = Math.abs(today - april15)
      return Math.ceil(diffTime / (1000 * 60 * 60 * 24))
    }
  },
  computed: {
    ...mapGetters('leaguetimes', [
      'player_name',
      'base',
      'range',
      'markType',
      'team'
    ]),
    ...mapGetters('user', [
      'currentLeagueName'
    ]),
    rangeLabel() {
      if(this.range?.shortcut) {
        return this.customShortcuts.find(e => {return e.value == this.range?.shortcut || e.key === this.range?.shortcut}).label
      } else if (Array.isArray(this.range) && this.range.length === 2) {
        return `${this.range[0]} - ${this.range[1]}`
      } else {
        return ''
      }
    },
    bases() {
      return [
        { text: '1 -> 2', value: 1 },
        { text: '2 -> 3', value: 2 },
        { text: '3 -> K', value: 3 }
      ]
    },
    baseLocal: {
      get() {
        return this.base
      },
      set(value) {
        this.SET_BASE(value)
      }
    },
    markTypeLocal: {
      get() {
        return this.markType
      },
      set(value) {
        this.SET_MARK_TYPE(value)
      }
    },
    isPlayLocal: {
      get() {
        return this.isPlay
      },
      set(value) {
        this.SET_IS_PLAY(value)
      }
    },
    localClub: {
      get() {
        return this.team
      },
      set(value) {
        this.SET_TEAM(value)
        this.refresh()
      }
    },
    customShortcuts() {
      return [
        { key: "summer", label: "Kesä", value: this.getDaysSinceApril15(), shortcut: "summer", isSelected: true },
        { key: 'thisYear', label: 'Tämä vuosi', value: 'year', isSelected: false },
        { key: 'lastYear', label: 'Viime vuosi', value: '-year', isSelected: false },
        { key: 'thisMonth', label: 'Tämä kk', value: 'month', isSelected: false },
        { key: 'lastMonth', label: 'Edellinen kk', value: '-month', isSelected: false },
        { key: 'last30Days', label: 'Viim 30 pv', value: 30, isSelected: false },
        { key: 'last7Days', label: 'Viim. 7 pv', value: 7, isSelected: false },
      ]
    }
  }
}
</script>